"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFullName = void 0;
const buildFullName = ({ firstName, lastName, }) => `${firstName} ${lastName}`;
exports.buildFullName = buildFullName;
//# sourceMappingURL=user_utils.js.map